import { Divider, Flex, Text } from "@chakra-ui/react";
import OutlineButton from "components/Button/OutlineButton";
import { useLoading } from "components/GlobalLoading/index";
import useAreaComumVinculadas from "core/features/area-comum/hooks/useAreaComumVinculadas";
import useDesvincularAreaComum from "core/features/area-comum/hooks/useDesvincularAreaComum";
import useVincularAreaComum from "core/features/area-comum/hooks/useVincularAreaComum";
import { useCurrentTenant } from "core/features/auth/tenant.store";
import colors from "core/resources/theme/colors";
import { showConfirm, showErrorAxios, showSuccess } from "infra/helpers/alerta";
import { useState } from "react";
import ModalVincularAreaComum from "../ModalVincularAreaComum";

export default function AreaComunVinculada({ id }: { id: string }) {
  const { tenant } = useCurrentTenant();

  const { mutate: vincularAreaComum, isLoading: isLoadingVincular } =
    useVincularAreaComum(tenant.id, id);

  const { mutate: desvincularAreaComum, isLoading: isLoadingDesvincular } =
    useDesvincularAreaComum(tenant.id, id);

  const [modalVincularOpen, setModalVincularOpen] = useState(false);

  const { data, isFetching, refetch } = useAreaComumVinculadas({
    tenantId: tenant.id,
    id,
  });

  const onError = (err: unknown) => {
    showErrorAxios(err);
  };

  const onSuccess = () => {
    showSuccess().then(() => {
      setModalVincularOpen(false);
      refetch();
    });
  };

  const _desvincularAreaComum = (id: string) => {
    desvincularAreaComum(id, {
      onError,
      onSuccess,
    });
  };

  const _vincularAreaComum = (id: string) => {
    vincularAreaComum(id, {
      onError,
      onSuccess,
    });
  };

  useLoading(isFetching || isLoadingVincular || isLoadingDesvincular);

  const areasComunsVinculadasIds = data?.map((item) => item.id) || [];

  return (
    <>
      <Flex flexDir="column" gap={4}>
        <Flex flexDir="column">
          <Text fontSize={"18px"} fontWeight={"bold"}>
            Áreas comuns vinculadas
          </Text>
          <Text>
            Permite vincular outras áreas comuns a esta área. Dessa forma,
            quando houver uma reserva feita para esta área comum,
            automaticamente as áreas vinculadas ficarão bloqueadas para uma nova
            reserva durante aquele período.
          </Text>

          <OutlineButton
            my={4}
            onClick={() => setModalVincularOpen(true)}
            maxW="240px"
          >
            Vincular nova área comum
          </OutlineButton>
        </Flex>

        {data?.map((item, index) => (
          <Flex key={item.id} flexDir="column">
            {index > 0 ? <Divider my={4} /> : null}
            <Flex
              align="center"
              fontSize="18px"
              fontWeight="medium"
              gap={4}
              mt={4}
            >
              {item.nome}
              <OutlineButton
                lineColor={colors.red}
                onClick={async () => {
                  const { isConfirmed } = await showConfirm();
                  if (isConfirmed) {
                    _desvincularAreaComum(item.id);
                  }
                }}
              >
                Remover
              </OutlineButton>
            </Flex>
          </Flex>
        ))}
      </Flex>

      <ModalVincularAreaComum
        isOpen={modalVincularOpen}
        onClose={() => setModalVincularOpen(false)}
        onSubmit={_vincularAreaComum}
        isLoading={isLoadingVincular}
        filterIds={[id, ...areasComunsVinculadasIds]}
      />
    </>
  );
}
